import React, { memo, useCallback } from 'react';

import TableCDS from '@sharedCR/coreDesignSystem/Table/TableCDS';
import PropTypes from 'prop-types';

const agenciesConfig = {
  id: {
    width: '10%',
    label: 'Id',
  },
  name: {
    width: '30%',
    label: 'Name',
  },
  address1: {
    width: '25%',
    label: 'Address1',
  },
  address2: {
    width: '10%',
    label: 'Address2',
  },
  city: {
    width: '10%',
    label: 'City',
  },
  state: {
    width: '5%',
    label: 'State',
  },
  zip: {
    width: '10%',
    label: 'Zip Code',
  },
};

const AgencyTable = ({ setInForm, agenciesData }) => {
  const onAgencyClick = useCallback(
    id => {
      if (!id) {
        return;
      }

      setInForm('selectedAgencyId', id, false);
    },
    [setInForm],
  );

  return (
    <TableCDS
      withSelectableRows
      config={agenciesConfig}
      data={agenciesData}
      onRowClick={onAgencyClick}
    />
  );
};

AgencyTable.propTypes = {
  agenciesData: PropTypes.array.isRequired,
  setInForm: PropTypes.func.isRequired,
};

export default memo(AgencyTable);
